// This enum represents the different types of milestones that can be tracked for projects

const FIRST_TOUCH = 'FIRST_TOUCH' as const;
const LAST_TOUCH = 'LAST_TOUCH' as const;
const LEAD_CREATED = 'LEAD_CREATED' as const;

const VALUES = [FIRST_TOUCH, LAST_TOUCH, LEAD_CREATED];

export type MilestoneKindType = (typeof VALUES)[number];

const VALUE_TO_LABEL = {
  [FIRST_TOUCH]: 'First Touch',
  [LAST_TOUCH]: 'Last Touch',
  [LEAD_CREATED]: 'Lead Created',
};

const getLabel = (kind: string): string => {
  // Handle any milestone kind string by formatting it with title case
  if (VALUE_TO_LABEL[kind as MilestoneKindType]) {
    return VALUE_TO_LABEL[kind as MilestoneKindType];
  }

  // Fallback formatting for unknown milestone kinds
  return kind
    .replace('_', ' ')
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const MilestoneKind = {
  FIRST_TOUCH,
  LAST_TOUCH,
  LEAD_CREATED,

  VALUES,
  getLabel,
};

export default MilestoneKind;
